import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import Styles from './Boleto25Video.css';
import { isBrowser } from '@/utils/browser';
import Script from 'next/script';

function Boleto25Video({ placeholderText, youtubeId, ...props }) {
  const [overlayVisible, setOverlayVisible] = useState(true);
  const player = useRef();

  useEffect(() => {
    if (!isBrowser()) return;

    window['onPlayerReady'] = (event) => {
      console.log('player ready');
    };

    window['onPlayerStateChange'] = (event) => {
      console.log(event.data, YT.PlayerState);
    };

    window['onYouTubeIframeAPIReady'] = () => {
      player.current = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: youtubeId,
        playerVars: {
          playsinline: 1,
          hl: 'ptBR',
          playsinline: 1,
          iv_load_policy: 0,
          fs: 0,
          enablejsapi: 1,
          cc_load_policy: 0,
        },
        events: {
          onReady: window['onPlayerReady'],
          onStateChange: window['onPlayerStateChange'],
        },
      });
    };
  }, [youtubeId]);

  return (
    <>
      <div className="c2c-video-container">
        <div {...props} className={clsx('c2c-video', props.className)}>
          {overlayVisible && (
            <div className="c2c-video-overlay">
              <div className="c2c-overlay-bg" />
              <img
                className="c2c-thumbnail"
                src={`https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`}
                alt=""
              />
              <button
                className="c2c-video-start"
                onClick={() => {
                  setOverlayVisible(false);
                }}
              >
                <img src="assets/boleto25/ic_play.svg" alt="reproduzir vídeo" />
              </button>
              {placeholderText && <p className="c2c-video-placeholder">{placeholderText}</p>}
            </div>
          )}
          <div className={clsx('c2c-video-player', !overlayVisible && 'enabled')}>
            <div id="player" />
          </div>
        </div>
      </div>
      <Script strategy="afterInteractive" src="https://www.youtube.com/iframe_api" />
      <style jsx>{Styles}</style>
    </>
  );
}

export default Boleto25Video;
